import type { ToolMeta } from "../types";

export const toolMeta = {
  slug: "heatmap-tracker",
  title: "Heatmap Tracker",
  description:
    "Prototype click heatmaps locally by placing hotspots on screenshots, seeding demo data, and exporting JSON.",
  category: "Design",
} satisfies ToolMeta;
